/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CatalogItemDescriptionInput,
  CatalogItemDescriptionTextInput,
  CatalogItemId,
  Language,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getAddServiceDescriptionUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/services/${id}/descriptions`;
};

/**
 * @summary Add service description
 */
export const addServiceDescription = async (
  id: CatalogItemId,
  catalogItemDescriptionInput: CatalogItemDescriptionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<Language> => {
  return customFetch<Language>(getAddServiceDescriptionUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(catalogItemDescriptionInput),
  });
};

export const getEditServiceDescriptionUrl = (id: CatalogItemId, language: Language) => {
  return `/api/v1/engineering/services/${id}/descriptions/${language}`;
};

/**
 * @summary Edit service description
 */
export const editServiceDescription = async (
  id: CatalogItemId,
  language: Language,
  catalogItemDescriptionTextInput: CatalogItemDescriptionTextInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditServiceDescriptionUrl(id, language), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(catalogItemDescriptionTextInput),
  });
};
